import 'core-js/stable';
import 'regenerator-runtime/runtime';

import $ from 'jquery';

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  // JavaScript to be fired on all pages
  $(document).on('click', '*[data-open*="#"]', function() {
    var selector = $($(this).attr('data-open'));
    if ($(this).hasClass('opened')) {
      selector.slideUp('fast');
      $(this).removeClass('opened');
      $('#js-pagetop').removeClass('menu-open');
    } else {
      var modalId;
      $('.modal').each(function() {
        modalId = $(this).attr('id');
        $(this).slideUp('fast');
        $('*[data-open="#' + modalId + '"]').removeClass('opened');
        $('#js-pagetop').removeClass('menu-open');
      });
      selector.slideToggle('fast');
      $(this).addClass('opened');
      $('#js-pagetop').addClass('menu-open');
    }
  });
  $('.close').on('click', function() {
    var modalId;
    modalId = $(this)
      .parents('.modal')
      .attr('id');
    $(this)
      .parents('.modal')
      .slideUp('fast');
    $('*[data-open="#' + modalId + '"]').removeClass('opened');
    $('#js-pagetop').removeClass('menu-open');
  });
  $('#js-overlay').on('click',function(){
    var modalId;
    modalId = $('.modal').attr('id');
    $('.modal').slideUp('fast');
    $('*[data-open="#'+modalId+'"]').removeClass('opened');
    $('#js-pagetop').removeClass('menu-open');
  });
});
